<script setup>
import store from '@/store';
import router from '@/router';
import { computed } from 'vue';

import { useRoute } from 'vue-router';
import { WELL_DYING_CODE } from '@/common/constants/ConstCode';
const route = useRoute();
const { params } = route;

const fnPushToForm = () => {
  store.commit('welldying/setDetail', {})
  store.commit('layout/setIsWellFloating');
  store.commit('welldying/setRegisterCategory', params.category);
  router.push(`/welldying/form?category=${params.category}`);
};

const fnPush = path => {
  if (path.includes('/my') && route.path.includes('/my')) {
    store.commit('layout/setIsWellFloating');
    return;
  }

  store.commit('layout/setIsWellFloating');
  store.commit('welldying/initPage');
  router.replace(path);
};

const isFloating = computed(() => store.getters['layout/getIsWellFloating']);

const outSideClick = event => {
  const menuEl = event.currentTarget.querySelector('.floating-menu');
  console.log('menuEl', menuEl);
  console.log('event.target', event.target);
  if (menuEl && !menuEl.contains(event.target)) {
    store.commit('layout/setIsWellFloating', false);
    store.dispatch('layout/removeAllModalComponent');
  }
};
</script>

<template>
  <div class="floating-dim right" :class="isFloating ? 'on' : ''" @click="outSideClick">
    <!-- right -->
    <ul class="floating-menu">
      <li @click.stop="fnPushToForm">
        <div class="thumb">
          <i class="ico-pencil"></i>
        </div>
        {{
          params.category === WELL_DYING_CODE.WELL_GOD.key
            ? '감사기도쓰기'
            : params.category === WELL_DYING_CODE.WELL_FAMILY.key
            ? '남기는 글'
            : '중보기도 쓰기'
        }}
      </li>
      <li
        v-if="params.category === WELL_DYING_CODE.WELL_PRAY.key"
        @click.stop="fnPush(`/welldying/${params.category}`)"
      >
        <div class="thumb">
          <i class="ico-fill-menu-more"></i>
        </div>
        <h6>전체 중보기도</h6>
      </li>
      <li @click.stop="fnPush(`/welldying/my/${params.category}`)">
        <div class="thumb">
          <i class="ico-fill-notepad"></i>
        </div>
        <h6>
          {{
            params.category === WELL_DYING_CODE.WELL_FAMILY.key
              ? '나의글 보기'
              : params.category === WELL_DYING_CODE.WELL_PRAY.key
              ? '내 중보기도'
              : '내기도문보기'
          }}
        </h6>
      </li>
    </ul>
  </div>
</template>

<style scoped>
.floating-menu {
  margin-bottom: 12rem;
}
</style>
